import { FC } from 'react';
import {
  IlogisticServiceDetails,
  LOCATION_PLACE_TYPE,
  LOGISTIC_SERVICE_STATUS_NAME
} from '../../../../../types/services';
import LogisticServiceToolCard from './Components/LogisticServiceToolCard/LogisticServiceToolCard';
import BordFloatIsland from 'components/BordFloatIsland/BordFloatIsland';
import useLogisticServicesState from 'state/useLogisticServicesState';
import { NudosSelectButton } from 'components/NudosComponents';
import BordDownloadQrModal from 'components/BordDownloadQrModal/BordDownloadQrModal';
import { IQrCard } from 'components/BordDownloadQrModal/Components/QRcard/QRcard';
import { UpdateToolsTrigger } from './Components/UpdateToolsTrigger/UpdateToolsTrigger';
import { OffboardingWarehouseToolsGroup } from './Components/OffboardingWarehouseToolsGroup/OffboardingWarehouseToolsGroup';

import './LogisticServiceDetailsTab3Tools.scss';

interface ILogisticServiceDetailsTab3Tools {
  updateDataCallback: () => Promise<void>;
  logisticServiceData: IlogisticServiceDetails;
}

const LogisticServiceDetailsTab3Tools: FC<ILogisticServiceDetailsTab3Tools> = ({
  logisticServiceData,
  updateDataCallback
}: ILogisticServiceDetailsTab3Tools) => {
  const { toolsSelected, setToolsSelected, openDownloadModal, setOpenDownloadModal } = useLogisticServicesState();
  
  const { statusName, originLocation, destinationLocation } = logisticServiceData;

  const isCancelled = statusName === LOGISTIC_SERVICE_STATUS_NAME.CANCELLED;

  const isUserOrigin = originLocation?.place === LOCATION_PLACE_TYPE.USER;
  const isWarehouseDestination = destinationLocation?.place === LOCATION_PLACE_TYPE.NUDOS;
  const isOffboardingToWarehouse = isUserOrigin && isWarehouseDestination;

  const qrList: IQrCard[] = toolsSelected?.map(item => ({
    qrData: {
      productId: String(item?.productId),
      serial: item.serial ?? '',
      orgName: logisticServiceData?.organization?.organizationName ?? ''
    }
  })) || [];

  const handleCloseCallback = () => {
    setToolsSelected(null);
    setOpenDownloadModal(false);
  };
  const handleOpenCallback = () => setOpenDownloadModal(true);

  const qrModal = (
    <BordDownloadQrModal
      downloadPercent={0}
      buttonProps={{
        isButtonDisabled: false,
        handleClick: handleCloseCallback
      }}
      closeModalCallback={handleCloseCallback}
      qrDataProps={qrList}
    />
  );

  const handleCheckAllTools = () => {
    const allTools =
      logisticServiceData?.tools?.map(item => ({
        serial: item.serial ?? '',
        productId: item.productId ?? null
      })) ?? null;

    const areAllSelected = toolsSelected?.length === logisticServiceData?.tools?.length;
    setToolsSelected(areAllSelected ? null : allTools);
  };

  const renderToolCards = () => {
    const hasTools = !!logisticServiceData && !!logisticServiceData.tools && logisticServiceData.tools.length > 0;

    if (!hasTools) return null;

    if (isOffboardingToWarehouse) {
      return (
        <OffboardingWarehouseToolsGroup
          tools={logisticServiceData.tools!}
          logisticServiceData={logisticServiceData}
          updateDataCallback={updateDataCallback}
        />
      );
    }

    return (
      <>
        {logisticServiceData.tools!.map((tool, index) => (
          <LogisticServiceToolCard
            key={`detail-card-${tool.productId}-idex-${index}-${tool.serial}`}
            toolData={tool}
            logisticServiceData={logisticServiceData}
            updateDataCallback={updateDataCallback}
          />
        ))}
      </>
    );
  };

  return (
    <div className="LogisticServiceDetailsTab3Tools">
      <div className="boxDetailsTab3Tools">
        <div className="titleContainer">
          <div className="titleTab3">Información de las herramientas</div>
          {isOffboardingToWarehouse && !isCancelled && (
            <UpdateToolsTrigger logisticServiceData={logisticServiceData} updateDataCallback={updateDataCallback} />
          )}
        </div>
        <div className="selectAllToolsContainer">
          <NudosSelectButton
            iconName="checkmark"
            handleClickButton={handleCheckAllTools}
            isButtonActive={toolsSelected?.length === logisticServiceData?.tools?.length}
            componentSize="xs w-2 h-2"
          />
          <span>Seleccionar todas las herramientas</span>
        </div>
        <div className="containerDetailTools">{renderToolCards()}</div>
      </div>
      {!!qrList?.length && (
        <BordFloatIsland
          leftContentCount={qrList?.length}
          leftContentText="Herramientas seleccionadas"
          onClose={handleCloseCallback}
          onButtonClick={handleOpenCallback}
          modal={qrModal}
          isModalOpen={openDownloadModal}
        />
      )}
    </div>
  );
};

export default LogisticServiceDetailsTab3Tools;
